/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingKey } from '../../models/setting-key';
import { UpdateSettingRequest } from '../../models/update-setting-request';

export interface ApiAdminSettingsKeyPut$Params {
  key: SettingKey;
      body?: UpdateSettingRequest
}

export function apiAdminSettingsKeyPut(http: HttpClient, rootUrl: string, params: ApiAdminSettingsKeyPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSettingsKeyPut.PATH, 'put');
  if (params) {
    rb.path('key', params.key, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAdminSettingsKeyPut.PATH = '/api/Admin/settings/{key}';
